import React from "react";
import { OUTBOUND_URL } from "../data/characters";
import { ArrowRight, Sparkles } from "lucide-react";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full overflow-hidden bg-white grid-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 pt-28 sm:pt-36 pb-20 sm:pb-28">
        {/* Top label */}
        <div
          data-testid="hero-label"
          className="reveal inline-flex items-center gap-2 border-2 border-black bg-white px-4 py-2 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase font-body"
        >
          <Sparkles className="w-3.5 h-3.5" /> AI Character Chat
        </div>

        {/* Massive H1 */}
        <h1
          data-testid="hero-title"
          className="reveal reveal-delay-1 font-display mt-8 text-5xl sm:text-7xl lg:text-[7rem] font-black tracking-tighter leading-[0.9] uppercase"
        >
          Chat With
          <br />
          <span className="relative inline-block">
            <span className="relative z-10">AI Characters</span>
            <span
              aria-hidden
              className="absolute left-0 bottom-2 sm:bottom-4 h-3 sm:h-5 w-full bg-[#00E5FF] -z-0"
            />
          </span>
          <br />
          That <em className="not-italic text-[#FF2D55]">Remember You.</em>
        </h1>

        {/* Subheading */}
        <div
          data-testid="hero-subtitle"
          className="reveal reveal-delay-2 mt-8 max-w-2xl space-y-4 text-lg sm:text-xl text-neutral-700 font-body leading-relaxed"
        >
          <p>
            Jump into character AI chat with personalities that feel alive
            from the first message. Choose an AI character, start a
            conversation and build stories that continue naturally instead of
            resetting every time you return.
          </p>
          <p>
            From cozy crushes and fantasy companions to dramatic villains,
            anime girls, roleplay partners and original characters — every AI
            character chat is built for immersive conversations, fast replies
            and long-form storytelling.
          </p>
        </div>

        {/* CTA Row */}
        <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row gap-5 items-start sm:items-center">
          <a
            data-testid="hero-cta-button"
            href={OUTBOUND_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="brutal-shadow inline-flex items-center gap-3 bg-black text-white font-display font-black uppercase tracking-tight text-base sm:text-lg px-7 sm:px-9 py-4 sm:py-5 border-2 border-black"
          >
            Start Character AI Chat
            <ArrowRight className="w-5 h-5" />
          </a>

          <a
            data-testid="hero-secondary-cta"
            href="#characters"
            className="inline-flex items-center gap-2 font-body font-semibold text-base sm:text-lg underline underline-offset-4 decoration-2 hover:decoration-[#00E5FF] transition"
          >
            Meet the Characters
          </a>
        </div>

        {/* Stats / trust row */}
        <dl
          data-testid="hero-stats"
          className="reveal reveal-delay-3 mt-16 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl border-t-2 border-black pt-8"
        >
          <div>
            <dt className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
              Characters
            </dt>
            <dd className="font-display text-3xl sm:text-4xl font-black mt-1">
              60+
            </dd>
          </div>
          <div>
            <dt className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
              Avg reply
            </dt>
            <dd className="font-display text-3xl sm:text-4xl font-black mt-1">
              0.4s
            </dd>
          </div>
          <div>
            <dt className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
              Languages
            </dt>
            <dd className="font-display text-3xl sm:text-4xl font-black mt-1">
              30+
            </dd>
          </div>
          <div>
            <dt className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
              Active chats
            </dt>
            <dd className="font-display text-3xl sm:text-4xl font-black mt-1">
              1.2M
            </dd>
          </div>
        </dl>
      </div>

      {/* Decorative shape */}
      <div
        aria-hidden
        className="hidden lg:block absolute -right-16 top-24 w-72 h-72 bg-[#FFD60A] rotate-12 -z-0"
      />
      <div
        aria-hidden
        className="hidden lg:block absolute right-32 top-72 w-40 h-40 rounded-full bg-[#FF2D55] -z-0"
      />
    </section>
  );
};

export default Hero;
